// Header.tsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../components/LanguageContext';
import '../styles/Header.css';

const routes = {
  about: '/about',
  projects: '/projects',
  skills: '/skills',
  contact: '/contact',
};

const Header: React.FC = () => {
  const { language, changeLanguage } = useLanguage();
  const [activeButton, setActiveButton] = React.useState<string>(routes.about);
  const [isMenuOpen, setMenuOpen] = React.useState<boolean>(false);
  const location = useLocation();

  React.useEffect(() => {
    setActiveButton(location.pathname);
  }, [location.pathname]);

  const handleClick = (route: string, elementId: string) => {
    setActiveButton(route);
    if (window.innerWidth <= 767) {
      setMenuOpen(false);
    }
    handleScrollToElement(elementId);
  };

  const handleMenuToggle = () => {
    setMenuOpen((prevMenuState) => !prevMenuState);
  };

  const handleLinkClick = () => {
    if (window.innerWidth <= 767) {
      setMenuOpen(false);
    }
  };

  const handleScrollToElement = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <nav>
        <div className="menu-toggle" onClick={handleMenuToggle}>
          <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
        </div>
        <ul className={`nav-list ${isMenuOpen ? 'open' : ''}`}>
          <Link
            to={routes.about}
            onClick={() => {
              handleClick(routes.about, 'about');
              handleLinkClick();
            }}
            className={`nav-button ${activeButton === routes.about ? 'active' : ''}`}
          >
            {language === 'es' ? 'Acerca de mí' : 'About'}
          </Link>
          <Link
            to={routes.projects}
            onClick={() => {
              handleClick(routes.projects, 'proyectos');
              handleLinkClick();
            }}
            className={`nav-button ${activeButton === routes.projects ? 'active' : ''}`}
          >
            {language === 'es' ? 'Proyectos' : 'Projects'}
          </Link>
          <Link
            to={routes.skills}
            onClick={() => {
              handleClick(routes.skills, 'skills-content');
              handleLinkClick();
            }}
            className={`nav-button ${activeButton === routes.skills ? 'active' : ''}`}
          >
            {language === 'es' ? 'Habilidades' : 'Skills'}
          </Link>
          <Link
            to={routes.contact}
            onClick={() => {
              handleClick(routes.contact, 'contact-content');
              handleLinkClick();
            }}
            className={`nav-button ${activeButton === routes.contact ? 'active' : ''}`}
          >
            {language === 'es' ? 'Contacto' : 'Contact'}
          </Link>
          <label className="language-toggle">
            <input
              type="checkbox"
              checked={language === 'en'}
              onChange={() => changeLanguage(language === 'es' ? 'en' : 'es')}
            />
            <span className="slider"></span>
            <span className="label-text">
              {language === 'es' ? 'Cambiar a inglés' : 'Switch to Spanish'}
            </span>
          </label>
        </ul>
      </nav>
    </header>
  );
};

export default Header;

